import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Kit de Emergencia para 30 días',
  desc: 'Checklist completa para preparar tu hogar correctamente.',
  price: '$12.000 ARS'
}, {
  num: 2,
  title: '50 alimentos que duran meses',
  desc: 'Qué almacenar y cómo hacerlo de manera inteligente.',
  price: '$10.000 ARS'
}, {
  num: 3,
  title: 'Plan Familiar ante Emergencias',
  desc: 'Plantilla práctica para organizar a toda tu familia.',
  price: '$9.000 ARS'
}, {
  num: 4,
  title: 'Cómo purificar agua en cualquier situación',
  desc: 'Métodos simples y reales para tener agua segura.',
  price: '$8.000 ARS'
}, {
  num: 5,
  title: 'Herramientas esenciales para un hogar preparado',
  desc: 'Qué realmente vale la pena tener y qué no.',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Plan de Preparación en 7 días',
  desc: 'Implementá el sistema rápidamente y sin abrumarte.',
  price: '$9.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-premium-gradient text-white pt-6 pb-6 px-5 relative" data-id="element-38">
      <div className="absolute inset-0 bg-radial-glow opacity-30 pointer-events-none" data-id="element-39" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-40">
        <div className="text-center mb-6" data-id="element-41">
          <h2 className="text-2xl md:text-4xl font-black mb-3 leading-tight" data-id="element-42">
            🎁 RECIBÍS TAMBIÉN LOS{' '}
            <span className="text-blue-400" data-id="element-43">6 BONOS</span> ESTRATÉGICOS
          </h2>
          <p className="text-xs text-blue-400/60 font-bold uppercase tracking-widest" data-id="element-44">
            Incluidos sin costo adicional
          </p>
        </div>

        <div className="space-y-4 mb-6" data-id="element-45">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 relative overflow-hidden transition-all hover:bg-white/10" data-id="element-46">
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-47">
                🎁 GRATIS
              </div>

              <div className="flex items-center gap-3 mb-2" data-id="element-48">
                <div className="bg-brand-yellow/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-49">
                  <span className="text-lg" data-id="element-50">🎁</span>
                </div>
                <span className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-51">
                  BONO {bonus.num}
                </span>
              </div>

              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-52">
                {bonus.title}
              </h3>
              <p className="text-xs text-gray-500 mb-3 leading-relaxed" data-id="element-53">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-2" data-id="element-54">
                <span className="text-sm text-gray-600 line-through" data-id="element-55">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-56">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white/5 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-57">
          <p className="text-gray-500 text-sm line-through mb-1" data-id="element-58">
            Valor total: +$55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-59">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-60">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}